import { BaseNotificationMessage, NotificationLink } from './base-notification-message';
import { NotificationDetail } from '../../types';

export function EOIAcceptedMessage({ notification }: { notification: NotificationDetail }) {
  const { metadata, entityId } = notification.relatedEntity;
  const actionUrl = entityId ? `/buying/offers/${entityId}` : undefined;

  return (
    <BaseNotificationMessage notification={notification}>
      Expression of Interest accepted for{' '}
      <NotificationLink to={actionUrl}>{metadata.opportunityTitle}</NotificationLink>
    </BaseNotificationMessage>
  );
}
